module.exports = __webpack_public_path__ + "static/image16-bfec0c84ef0a332f3e58bde111acc7fd.png";